import React from 'react'
import clsx from 'clsx'

import { Container } from '../Container'
import { DEFAULT_DRAWER_WIDTH, useDrawerStyles } from './styles'

interface Props {
    open: boolean
    width?: number
    children?: React.ReactNode
}

export const SideDrawerContainer: React.FC<Props> = (props) => {
    const drawerWidth = props.width ?? DEFAULT_DRAWER_WIDTH
    const drawerClasses = useDrawerStyles(props.width)

    return (
        <Container
            className={clsx(drawerClasses.content, {
                [drawerClasses.contentShift]: props.open,
            })}
            flex={1}
            style={{
                minWidth: 0,
                width: props.open ? `calc(100% - ${drawerWidth}px)` : '100%',
            }}
        >
            {props.children}
        </Container>
    )
}
